// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 982 ? "product-detail" : chunkId) + "." + {"22":"0be38346","809":"545719ec","982":"ccf5df70"}[chunkId] + ".css";
};